import {useEffect, useMemo, useRef, useState} from "react";

import {RegionType} from "@pg-rp/common-types";

import {IInteractiveRegion} from "../types/IInteractiveRegion";
import {getMainCityBySelectedRegions} from "../utils/get_main_city_by_selected_regions";
import {validateSelectedRegionsWithAvailableDistrictsAndSurroundings} from "../utils/validate_selected_regions_with_available_districts_and_surroundings";
import {useInteractiveRegionsMapContext} from "./use_interactive_regions_map_context";

type IWaitForRegionCallback = (props: {hasValidSurroundings?: boolean; hasAnyValidDistricts?: boolean}) => void;

export const useMapRegionDistrictsAndSurroundings = () => {
    const newRegionCallbackQ = useRef<IWaitForRegionCallback[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [mainRegion, setMainRegion] = useState<IInteractiveRegion | null>(null);
    const [availableDistrictsAndSurroundings, setAvailableDistrictsAndSurroundings] = useState<IInteractiveRegion[] | null>(null);

    const {selectedRegions, getMainRegion, getDistrictsAndSurroundings} = useInteractiveRegionsMapContext();

    const parentId = useMemo(() => {
        if (!selectedRegions) {
            return null;
        }

        return getMainCityBySelectedRegions(selectedRegions);
    }, [selectedRegions]);

    useEffect(() => {
        if (!parentId) {
            setMainRegion(null);
            setAvailableDistrictsAndSurroundings(null);
            return;
        }

        (async () => {
            setIsLoading(true);
            try {
                const mainRegionData = await getMainRegion(parentId);
                const districtsAndSurroundingsData = await getDistrictsAndSurroundings(parentId);

                setMainRegion(mainRegionData);
                setAvailableDistrictsAndSurroundings(districtsAndSurroundingsData);
                setIsLoading(false);
            } catch {
                setIsLoading(false);
            }
        })();
    }, [parentId]);

    const regions = useMemo(() => {
        if (!availableDistrictsAndSurroundings || !mainRegion) {
            return {
                districts: [],
                surroundings: [],
                main: null
            };
        }

        return {
            districts: availableDistrictsAndSurroundings.filter((region) => region.type === RegionType.DISTRICT),
            surroundings: availableDistrictsAndSurroundings.filter((region) => region.type !== RegionType.DISTRICT),
            main: mainRegion
        };
    }, [availableDistrictsAndSurroundings, mainRegion]);

    useEffect(() => {
        if (isLoading) {
            return;
        }

        const hasValidSurroundings = validateSelectedRegionsWithAvailableDistrictsAndSurroundings(
            selectedRegions || [],
            availableDistrictsAndSurroundings || []
        );
        const hasAnyValidDistricts = !!availableDistrictsAndSurroundings?.some((region) => region.type === RegionType.DISTRICT);
        newRegionCallbackQ.current.forEach((callback) =>
            callback({
                hasValidSurroundings,
                hasAnyValidDistricts
            })
        );
        newRegionCallbackQ.current = [];
    }, [isLoading, availableDistrictsAndSurroundings, parentId]);

    return {
        hasAnyDistrictsOrSurroundings: regions.districts.length > 0 || regions.surroundings.length > 0,
        regions,
        availableDistrictsAndSurroundings,
        isLoading,
        parentId,
        waitForRegion: (callback: IWaitForRegionCallback) => {
            newRegionCallbackQ.current.push(callback);
        }
    };
};
import {useEffect, useMemo, useRef, useState} from "react";

import {RegionType} from "@pg-rp/common-types";

import {IInteractiveRegion} from "../types/IInteractiveRegion";
import {getMainCityBySelectedRegions} from "../utils/get_main_city_by_selected_regions";
import {validateSelectedRegionsWithAvailableDistrictsAndSurroundings} from "../utils/validate_selected_regions_with_available_districts_and_surroundings";
import {useInteractiveRegionsMapContext} from "./use_interactive_regions_map_context";

type IWaitForRegionCallback = (props: {hasValidSurroundings?: boolean; hasAnyValidDistricts?: boolean}) => void;

export const useMapRegionDistrictsAndSurroundings = () => {
    const newRegionCallbackQ = useRef<IWaitForRegionCallback[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [mainRegion, setMainRegion] = useState<IInteractiveRegion | null>(null);
    const [availableDistrictsAndSurroundings, setAvailableDistrictsAndSurroundings] = useState<IInteractiveRegion[] | null>(null);

    const {selectedRegions, getMainRegion, getDistrictsAndSurroundings} = useInteractiveRegionsMapContext();

    const parentId = useMemo(() => {
        if (!selectedRegions) {
            return null;
        }

        return getMainCityBySelectedRegions(selectedRegions);
    }, [selectedRegions]);

    useEffect(() => {
        if (!parentId) {
            setMainRegion(null);
            setAvailableDistrictsAndSurroundings(null);
            return;
        }

        (async () => {
            setIsLoading(true);
            try {
                const mainRegionData = await getMainRegion(parentId);
                const districtsAndSurroundingsData = await getDistrictsAndSurroundings(parentId);

                setMainRegion(mainRegionData);
                setAvailableDistrictsAndSurroundings(districtsAndSurroundingsData);
                setIsLoading(false);
            } catch {
                setIsLoading(false);
            }
        })();
    }, [parentId]);

    const regions = useMemo(() => {
        if (!availableDistrictsAndSurroundings || !mainRegion) {
            return {
                districts: [],
                surroundings: [],
                main: null
            };
        }

        return {
            districts: availableDistrictsAndSurroundings.filter((region) => region.type === RegionType.DISTRICT),
            surroundings: availableDistrictsAndSurroundings.filter((region) => region.type !== RegionType.DISTRICT),
            main: mainRegion
        };
    }, [availableDistrictsAndSurroundings, mainRegion]);

    useEffect(() => {
        if (isLoading) {
            return;
        }

        const hasValidSurroundings = validateSelectedRegionsWithAvailableDistrictsAndSurroundings(
            selectedRegions || [],
            availableDistrictsAndSurroundings || []
        );
        const hasAnyValidDistricts = !!availableDistrictsAndSurroundings?.some((region) => region.type === RegionType.DISTRICT);
        newRegionCallbackQ.current.forEach((callback) =>
            callback({
                hasValidSurroundings,
                hasAnyValidDistricts
            })
        );
        newRegionCallbackQ.current = [];
    }, [isLoading, availableDistrictsAndSurroundings, parentId]);

    return {
        hasAnyDistrictsOrSurroundings: regions.districts.length > 0 || regions.surroundings.length > 0,
        regions,
        availableDistrictsAndSurroundings,
        isLoading,
        parentId,
        waitForRegion: (callback: IWaitForRegionCallback) => {
            newRegionCallbackQ.current.push(callback);
        }
    };
};
